import {RaEvent, RaEventType} from "./RaEvent";
import {AudioQueueItem} from "../services/audio-playback/audioqueue.item";

export enum InterruptAudio {
    YES,
    NO
}

export class AudioQueueEvent extends RaEvent {

    static TYPE:RaEventType = "audio_queue_event";
    private playlist:AudioQueueItem[] = [];
    private interrupt;

    constructor(playlist: AudioQueueItem[],
                interrupt: InterruptAudio) {
        super(AudioQueueEvent.TYPE);
        this.playlist = playlist;
        this.interrupt = interrupt;
    }

    public shouldInterrupt(): boolean {
        return this.interrupt === InterruptAudio.YES;
    }

    public getPlayList(): AudioQueueItem[] {
        return this.playlist;
    }
}
